import { BlocksIconReplace } from 'blocks-nextjs/blocks-web-components/components/icon/icons/replace';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconReplace = createComponent({ react: React, tagName: 'cat-icon-replace', elementClass: BlocksIconReplace });
